<template>
  <div class="page-main">
    <div class="myHead">
      <el-breadcrumb style="margin-top:20px;margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager'}">应急监控中心</el-breadcrumb-item>
        <el-breadcrumb-item></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="innerBox">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="实时监测" name="first">
          <monitor v-if="activeName === 'first'"></monitor>
        </el-tab-pane>
        <!-- <el-tab-pane label="地图" name="second">
          <template v-show="tabIndex === 1">
            <Map />
          </template>
        </el-tab-pane> -->
        <!-- <el-tab-pane label="气体监测" name="third">
          <gas-monitor v-if="tabIndex == 1"></gas-monitor>
        </el-tab-pane> -->
        <el-tab-pane label="预警报警" name="fourth">
          <early-warning v-if="tabIndex == 1"></early-warning>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import monitor from './monitor';
  import gasMonitor from './gasMonitor'
  import Map from './map/map'
  import earlyWarning from './earlyWarning'
  export default {
    name: 'processViewMonitor',
    components: {
      monitor,
      gasMonitor,
      Map,
      earlyWarning
    },
    data() {
      return {
        activeName: 'first',
        tabIndex: ''
      }
    },
    methods: {
      handleClick(tab, event) {
        this.tabIndex = tab.index
      }
    }
  }
</script>

<style scoped lang="scss">
  .page-main {
    height: 100%;
    width: 100%;
    // overflow: scroll
  }
  .myHead {
    position: absolute;
    top: 0px;
    left: 250px;
    width: 80%;
    height: 60px;
  }
  .innerBox {
    margin: auto;
    width: 100%;
    height: 100%;
    // overflow: scroll;
    background: #f2f2f2;
    border: 1px solid rgb(232, 232, 232);
    padding: 10px 20px;
    & ::v-deep .el-tabs {
      height: 100%;
       .el-tabs__content {
        height: calc(100% - 55px);
        position: none;
        overflow: auto;
        .el-tab-pane {
          height: 100%;
          position: relative;
        }
      }
    }
  }
</style>
